import { render, staticRenderFns } from "./SeedsView.vue?vue&type=template&id=863b24fe&scoped=true&"
import script from "./SeedsView.vue?vue&type=script&lang=js&"
export * from "./SeedsView.vue?vue&type=script&lang=js&"
import style0 from "./SeedsView.vue?vue&type=style&index=0&id=863b24fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b24fe",
  null
  
)

export default component.exports